import LogosImage from "../assets/logos.png"
import "../css/databasePage.css";

export default function About() {
  // const [value1, setValue1] = React.useState("Assessment Time");
  return (
    <div className="container">
      <p>C40 cities led the development of the Healthy Neighbourhood Explorer with support from key partners shown below.</p>
      <br/>
      <p><strong>Funder:</strong> Novo Nordisk</p>
      <br />
      <p><strong>Technical partners:</strong> Arup, Chair Enterpreneurship Territory Innovation - Chaire-ETI and Spacescape</p>
      <br />
      <p><strong>Tool developer:</strong> Inetum</p>
      <br />
      <p><strong>Contributors:</strong></p>
      <p>Technical input and review of the quantitative impact of urban actions on Healthy Neighbourhood indicators by: 
        Markus Berensson (C40), Kauê Braga (C40), Christina Xiao (C40), Mariana Nicoletti (formerly of C40), Christina Riccetto-Murfitt (C40), Honorine van den Broek d’Obrenan (C40), Daniel Firth (C40), Carl Higgs (RMIT), Melanie Lowe (RMIT)</p>
      <div style={{ marginTop: '115px' }}>
        <p><img style={{maxWidth: '100%', height: 'auto', display: 'block'}}src={LogosImage} alt="representation of the General equation underpinning the tool"></img></p>
      </div>
    </div>
  );
}
